import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('eco_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('eco_token');
      localStorage.removeItem('eco_user');
      if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export const formatPrice = (price) => {
  return new Intl.NumberFormat('kk-KZ').format(price).replace(/[,\u00a0]/g, ' ') + ' тг';
};

export const getHouseTypeLabel = (type) => {
  const labels = { pool: 'Бассейнді', family: 'Отбасылық', spa: 'СПА' };
  return labels[type] || type;
};

export const getStatusLabel = (status) => {
  const labels = {
    pending_payment: 'Төлем күтілуде', paid: 'Төленді', in_progress: 'Жүріп жатыр',
    completed: 'Аяқталды', cancelled: 'Отменён', refunded: 'Қайтарылды',
    new: 'Новый', accepted: 'Принято', preparing: 'Готовится',
    ready: 'Готово', delivered: 'Доставлено'
  };
  return labels[status] || status;
};

export const getStatusColor = (status) => {
  const colors = {
    pending_payment: 'bg-yellow-900/30 text-yellow-400',
    paid: 'bg-green-900/30 text-green-400',
    in_progress: 'bg-blue-900/30 text-blue-400',
    completed: 'bg-gray-700/30 text-gray-300',
    cancelled: 'bg-red-900/30 text-red-400',
    refunded: 'bg-orange-900/30 text-orange-400',
    new: 'bg-blue-900/30 text-blue-400',
    accepted: 'bg-cyan-900/30 text-cyan-400',
    preparing: 'bg-yellow-900/30 text-yellow-400',
    ready: 'bg-emerald-900/30 text-emerald-400',
    delivered: 'bg-green-900/30 text-green-400'
  };
  return colors[status] || 'bg-muted text-muted-foreground';
};

// Order status flow: new → accepted → preparing → ready → delivered
export const ORDER_STATUS_FLOW = ['new', 'accepted', 'preparing', 'ready', 'delivered'];
export const getNextOrderStatus = (status) => {
  const idx = ORDER_STATUS_FLOW.indexOf(status);
  if (idx === -1 || idx === ORDER_STATUS_FLOW.length - 1) return null;
  return ORDER_STATUS_FLOW[idx + 1];
};

// Get current admin user from localStorage
export const getCurrentUser = () => {
  try { return JSON.parse(localStorage.getItem('eco_user') || 'null'); }
  catch { return null; }
};
export const isSuperadmin = () => getCurrentUser()?.role === 'superadmin';
